(() => {
  const GROUP_SELECTOR = '.shopify-section';
  const CARD_SELECTOR = 'product-card';
  const INNER_SELECTOR = '[data-product-details-inner]';
  const DETAILS_SELECTOR = '.product-card__details';

  const groups = new Map();

  const measure = (groupEl) => {
    const details = [];
    let max = 0;

    groupEl.querySelectorAll(CARD_SELECTOR).forEach((card) => {
      const inner = card.querySelector(INNER_SELECTOR);
      const detail = card.querySelector(DETAILS_SELECTOR);
      if (!inner || !detail) return;
      const height = inner.offsetHeight;
      if (height > max) max = height;
      details.push(detail);
    });

    if (details.length < 2) {
      details.forEach((detail) => {
        detail.style.minHeight = '';
      });
      return;
    }

    details.forEach((detail) => {
      detail.style.minHeight = `${max}px`;
    });
  };

  const schedule = (groupEl) => {
    const group = groups.get(groupEl);
    if (!group || group.frame) return;
    group.frame = requestAnimationFrame(() => {
      group.frame = 0;
      measure(groupEl);
    });
  };

  const resizeObserver = new ResizeObserver((entries) => {
    const touched = new Set();
    entries.forEach((entry) => {
      const groupEl = entry.target.closest(GROUP_SELECTOR);
      if (groupEl) touched.add(groupEl);
    });
    touched.forEach(schedule);
  });

  const register = (root) => {
    (root || document).querySelectorAll(CARD_SELECTOR).forEach((card) => {
      const inner = card.querySelector(INNER_SELECTOR);
      if (!inner) return;
      const groupEl = card.closest(GROUP_SELECTOR);
      if (!groupEl) return;
      if (!groups.has(groupEl)) groups.set(groupEl, { frame: 0 });
      resizeObserver.observe(inner);
    });
    groups.forEach((_, groupEl) => schedule(groupEl));
  };

  let rescanFrame = 0;
  const scheduleRescan = () => {
    if (rescanFrame) return;
    rescanFrame = requestAnimationFrame(() => {
      rescanFrame = 0;
      register();
    });
  };

  const init = () => {
    register();

    new MutationObserver((mutations) => {
      if (mutations.some((mutation) => mutation.addedNodes.length)) scheduleRescan();
    }).observe(document.body, { childList: true, subtree: true });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => groups.forEach((_, groupEl) => schedule(groupEl)));
    }

    document.addEventListener('shopify:section:load', scheduleRescan);
    document.addEventListener('shopify:section:select', scheduleRescan);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
